// @flow strict
import * as React from 'react'

import styles from './Card.module.scss'

import Label from './Label'
import Metadata from './Metadata'

type Props = {
  children: React.ChildrenArray<
    React.Element<typeof Label> | React.Element<typeof Metadata>,
  >,
}

const ContentHeader = (props: Props) => (
  <div className={styles.contentHeader}>{props.children}</div>
)

export default ContentHeader
